
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const SacramentStatus = {
  BOTH: 'BOTH',
  ONLY_ONE: 'ONLY_ONE',
  NONE: 'NONE'
} as const

export type SacramentStatus = (typeof SacramentStatus)[keyof typeof SacramentStatus]


export const Role = {
  ADMIN: 'ADMIN',
  USER: 'USER'
} as const

export type Role = (typeof Role)[keyof typeof Role]
